<template>
  <v-container>
    <v-main>
      <v-row justify="center">
        <v-col cols="12">
          <div class="g-card-container">
            <div class="g-card">
              <div class="g-card-header">
                <h3 class="gm-whitish--text">Excellence</h3>
              </div>
              <div class="g-card-content">
                <p class="gm-darkblue--text">Excellence in service delivery is how we uphold our cherished reputation, we ensure that work done exceeds minimum permissible standards as we proffer innovative solutions to complex problems as they arise.</p>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>

      <hr />
      <br />

      <v-row justify="center">
        <v-col cols="12">
          <div class="g-card-container">
            <div class="g-card">
              <div class="g-card-header">
                <h3 class="gm-whitish--text">Safety</h3>
              </div>
              <div class="g-card-content">
                <p class="gm-darkblue--text"><b>Personnel safety</b> is among our top priorities in job execution, and we ensure that our staff are trained and retrained on protective measures and situation response in case of emergency. We also provide adequate PPE and ensure that our staff use them correctly.</p>
                <p class="gm-darkblue--text"><b>Environmental safety</b> is paramount to our operation, we have developed procedures for the safe handling of chemicals and waste disposal to avoid contaminating the environment and endangering our host communities.</p>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>

      <hr />
      <br />

      <v-row justify="center">
        <v-col cols="12">
          <div class="g-card-container">
            <div class="g-card">
              <div class="g-card-header">
                <h3 class="gm-whitish--text">Reliability</h3>
              </div>
              <div class="g-card-content">
                <p class="gm-darkblue--text">We deliver on our promises, our projects are always closely managed to ensure we deliver the desired quality within the specified budget and schedule.</p>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-main>
  </v-container>
</template>

<script>
export default {
  name: 'core-values'
}
</script>

<style scoped>

</style>
